<template>
  <div>
    <h1>molecules</h1>

    <h2>buttons</h2>

    <div class="row">
      <div class="span-16-lg">
        <nav-button type="next">next</nav-button>
        <nav-button type="back">back</nav-button>
        <nav-button type="share">share</nav-button>
        <nav-button type="next" customclass="call-to-action">begin</nav-button>
        <nav-button type="next" customclass="button-disabled">submit</nav-button>
      </div>
    </div>

    <h2>card with rollover</h2>

    <div class="row">
      <rollover-card spanclass="span-4-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs" ratioclass="ratio-flip-card">content here</rollover-card>
    </div>

    <h2>Card with 3D flip effect and rollover</h2>
    <p>(click to rotate)</p>

    <div class="row">
      <flip-card icon="culture"></flip-card>
      <flip-card icon="role-models"></flip-card>
      <flip-card icon="networks"></flip-card>
    </div>

    <h2>progress selectors (click in order)</h2>

    <div class="row">
      <div class="span-9-lg offset-1-lg span-8-md overflow-hidden">
        <progress-selector>first</progress-selector>
        <progress-selector>second</progress-selector>
        <progress-selector>third</progress-selector>
        <progress-selector>fourth</progress-selector>
      </div>
    </div>


    <h2>popup notification</h2>

    <h3>correct</h3>
    
    <div class="row">
      <popup-notification type="correct" title="you've got it!">{{popup_text}}</popup-notification>
    </div>

    <h3>incorrect</h3>

    <div class="row">
      <popup-notification type="incorrect" title="not quite">{{popup_text}}</popup-notification>
    </div>

  </div>
</template>

<script>
  import button from '../../components/molecules/button'
  import rollover_card from '../../components/molecules/rollover_card'
  import flip_card from '../../components/molecules/flip_card'
  import progress_selector from '../../components/molecules/progress_selector'
  import popup_notification from '../../components/molecules/popup_notification'

  export default {
    components: {
      'nav-button': button,
      'rollover-card': rollover_card,
      'flip-card': flip_card,
      'progress-selector': progress_selector,
      'popup-notification': popup_notification
    },
    data () {
      return {
        popup_text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// molecules.vue?fe6f127a